<template>
    <v-card class="mx-auto" max-width="344">
        <v-img :src="event_object.cover_img" height="200px" class="right-align">
            <v-chip :color="event_status_color" :class="buttonClasses">{{event_object.status}}</v-chip>
        </v-img>

        <v-card-subtitle tabindex="0" class="pb-1">
            <h3>{{event_object.title}}</h3>
        </v-card-subtitle>

        <v-card-subtitle tabindex="0" class="pt-1">
            <h4><v-icon>event</v-icon> {{event_object.to_date?(niceDate(event_object.from_date)+' - '+ niceDate(event_object.to_date)):niceDate(event_object.from_date)}}</h4>
            <h4><v-icon>location_pin</v-icon> {{event_object.location}}</h4>
        </v-card-subtitle>
       

        <v-card-text tabindex="0">
            <div class="event-description-box">
                {{event_object.description}}
            </div>

        </v-card-text>
        <v-card-actions>
            
            <v-btn color="indigo lighten-2" text v-if="event_object.live_link && event_object.status=='ongoing'">
                Join Now
            </v-btn>

            <v-btn color="indigo lighten-2" text v-if="event_object.status=='upcoming'" @click="dialogRegister=!dialogRegister">
                Register Now
            </v-btn>
            <!-- <v-btn color="indigo lighten-2" text :aria-label="`Read more about ${event_object.title}`">
                Read More
            </v-btn> -->
        </v-card-actions>

        <v-dialog v-model="dialogRegister" max-width="500px" persistent>
            <event-registration :event_id="event_object.id" :event_title="event_object.title" :approv_type="event_object.approv_type" @close-form="dialogRegister=!dialogRegister"></event-registration>
        </v-dialog>

    </v-card>
</template>

<script>
    import EventRegistration from './EventRegistration.vue';

export default {
    name: 'EventItem',
    props: {
        event_object: Object,
    },
    components:{
        EventRegistration 
    },
    data: () => ({
        show: false,
        dialogRegister:false,
        event_status_color: '',
    }),
    created() {
        switch (this.event_object?.status) {
            case 'upcoming':
                this.event_status_color = "warning"
                break;
            case 'ongoing':
                this.event_status_color = "success"
                break;
            default:
                this.event_status_color = ""
        }
     
        if(this.$route.query.tl && this.$route.query.tl == this.event_object.id){
            this.dialogRegister=!this.dialogRegister
        }
    },
    methods:{
        niceDate(dateVal){
            var d = new Date(dateVal)
            return d.toDateString()
        }
    },
    computed: {
        buttonClasses() {
            return this.event_object?.status == "ongoing" ? "ma-2 pulse-button" : "ma-2";
        }
    }
}
</script>

<style scoped>
.right-align {
    text-align: right;
}

/* .event-description-box {
    min-height:100px;
    max-height: 150px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;

} */

.pulse-button {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
}
</style>